/**
 * @generated SignedSource<<304a976aa255c713c0d833386aaaf6ba>>
 * @relayHash 72bd6e486f65b6dfdcf5823f8e8d932a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba5d39b93fcadc77d7a70f392a7dc2b089f79a50b5ab00379aa98f8eb412c455

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JswExpandableProjectQuery } from './JswExpandableProjectQuery.graphql';

const node: PreloadableConcreteRequest<JswExpandableProjectQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ba5d39b93fcadc77d7a70f392a7dc2b089f79a50b5ab00379aa98f8eb412c455",
    "metadata": {},
    "name": "JswExpandableProjectQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
